module.exports = __webpack_public_path__ + "img/uv-open.b619e5a5.png";